import { openIntercom } from 'BreetHelpers';

export interface IDialogAlert {
	title?: string;
	description?: string;
}

export type AlertActionType = 'support';

export const AlertActions: Record<AlertActionType, (message?: string) => void> = {
	support: (intercomPreMessage?: string) => openIntercom(intercomPreMessage)(),
};
